module.exports = __webpack_public_path__ + "static/media/tebet.3a70ec65.jpeg";